import toast from "react-hot-toast";

type ToastType = "success" | "error" | "loading" | "custom";

interface ToastOptions {
  duration?: number;
  position?:
    | "top-right"
    | "top-center"
    | "top-left"
    | "bottom-right"
    | "bottom-center"
    | "bottom-left";
  icon?: string | JSX.Element;
}

const defaultOptions: ToastOptions = {
  duration: 4000,
  position: "top-right",
};

class ToastService {
  static success(message: string, options: ToastOptions = {}) {
    return toast.success(message, {
      ...defaultOptions,
      ...options,
    });
  }

  static error(message: string, options: ToastOptions = {}) {
    return toast.error(message, {
      ...defaultOptions,
      ...options,
      duration: options.duration || 5000,
    });
  }

  static loading(message: string, options: ToastOptions = {}) {
    return toast.loading(message, {
      ...defaultOptions,
      ...options,
    });
  }

  static dismiss(toastId: string) {
    toast.dismiss(toastId);
  }

  static promise<T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    },
    options: ToastOptions = {}
  ) {
    return toast.promise(
      promise,
      {
        loading: messages.loading,
        success: messages.success,
        error: messages.error,
      },
      {
        ...defaultOptions,
        ...options,
      }
    );
  }
}

export default ToastService;
